module.exports = __webpack_public_path__ + "img/chevron_right_24px.1b5d5da2.svg";